import { render, staticRenderFns } from "./PromoInfoPrev.vue?vue&type=template&id=bc65359e&scoped=true&"
import script from "./PromoInfoPrev.vue?vue&type=script&lang=js&"
export * from "./PromoInfoPrev.vue?vue&type=script&lang=js&"
import style0 from "./PromoInfoPrev.vue?vue&type=style&index=0&id=bc65359e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc65359e",
  null
  
)

export default component.exports